
<script>
  import PTabNav from './PTabNav';
  import PubSub from 'pubsub-js';
  export default {
    name: "PTabs",
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      beforeClick: {
        type: Function,
        default(){
          return function () {};
        }
      }
    },
    components: {
      PTabNav
    },
    data(){
      return {
        pTabPanes: [],
        currentName: this.value || 0
      }
    },
    methods: {
      addPane(pane){
        this.pTabPanes.push(pane);
        if(!this.currentName){
          this.setCurrentName(this.pTabPanes[0].name);
        }
      },
      removePane(pane){
        let index = this.pTabPanes.indexOf(pane);
        if(index > -1){
          this.pTabPanes.splice(index, 1);
        }
      },
      setCurrentName(name){
        if(this.currentName !== name){
          this.currentName = name;
          this.$emit('input', name);
        }
      },
      // 标签页点击事件
      handTabNavClick(name, pane, e){
        if(this.currentName === name || pane.disabled){
          return;
        }

        let before = this.beforeClick();
        if(before && before.then){
          before.then(() => {
            this.setCurrentName(name);
            this.$emit('tabClick', pane, e);
          })
        }else{
          this.setCurrentName(name);
          this.$emit('tabClick', pane, e);
        }
      }
    },
    watch: {
      value(newVal){
        this.setCurrentName(newVal);
      },
      currentName(){
        this.$nextTick(() => {
          this.$refs.p_tab_nav.scrollToActiveTab();
        });
      }
    },
    render(h) {
      let {$scopedSlots} = this;
      let $default = $scopedSlots.default();
      let qTabPanes = $default.map(item => {
        /* 过滤<PTabs>xxx</PTabs>中传递的xxx内容。这里只接收<PTabPane>组件，因为我们需要根据<PTabPane>组件的数量来生成
         * <PTabNav>组件，如果参差了其它节点则会导致不能正确生成<PTabNav>组件 */
        if(item.componentOptions && item.componentOptions.tag === 'PTabPane'){
          return item;
        }
      });

      let qTab = h('PTabNav', {
        props: {
          // 将tab-pane传递给 <PTabNav>组件，<PTabNav>组件就知道要有多少个tab-item了
          tabPanes: this.pTabPanes,
          handTabNavClick: this.handTabNavClick
        },
        ref: 'p_tab_nav'
      });
      let qTabBody = h('div', {
        staticClass: 'p-tabs__content',
        ref: 'tabs_content',
      }, qTabPanes);


      // console.log('当前页面', $default)
      return h('div', {
        staticClass: 'p-tabs'
      }, [qTab, qTabBody]);
    },
    mounted() {
      PubSub.publish('tabsContent',this.$refs.tabs_content);
      //console.log(this)
      this.$nextTick(() => {
        this.$refs.p_tab_nav.scrollToActiveTab();
      });
    }
  }
</script>

<style lang="stylus">
.p-tabs{
  ::scrollbar {
    height: 4px;
  }
  ::scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0);
  }
  ::scrollbar-thumb:vertical {
      background-color: #bfbfbf;
  }
  ::scrollbar-thumb:horizontal {
      background-color: #bfbfbf;
  }

  ::-webkit-scrollbar {
    height: 4px;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0);
  }
  ::-webkit-scrollbar-thumb:vertical {
      background-color: #bfbfbf;
  }
  ::-webkit-scrollbar-thumb:horizontal {
      background-color: #bfbfbf;
  }



  .p-tabs__header{
    position: relative;
    // margin-bottom: 15px;
    &.is-scrollable{
      // padding-left: 20px;
      // padding-right: 20px;
      padding: 0 26px;
    }
  }
  .p-tabs__header_fixed {
    position: fixed;
    margin-top: 50px;
    top: 0;
    z-index: 999;
    border: 1px solid #d1d1d1;
    background-color: #f8f8f8;
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.44);
    -webkit-box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.44);
  }
  .p-tabs__nav-prev,
  .p-tabs__nav-next{
    position: absolute;
    top: 0;
    width: 20px;
    height: 100%;
    display: none;
    &::before{
      position: absolute;
      content: ' ';
      font-size: 0;
      line-height: 0;
      width: 10px;
      height: 10px;
      top: 50%;
      left: 50%;
      border-top: 1px solid #00336f;
      border-left: 1px solid #00336f;
      margin: -5px 0 0 -5px;
    }
    cursor: pointer;
    &.disabled{
      cursor: default;
      border-color: #00336f;
    }
  }
  .p-tabs__nav-prev{
    left: 0;
    &:before{
      transform: rotate(-45deg);
    }
  }
  .p-tabs__nav-next{
    right: 0;
    &:before{
      transform: rotate(135deg);
    }
  }
  .p-tabs__header{
    &.is-scrollable{
      .p-tabs__nav-prev,
      .p-tabs__nav-next{
        display: block;
      }
    }
  }
  .p-tabs__nav-scroll{
    // overflow: hidden;
    overflow-y: auto;
  }
  .p-tabs_nav-list{
    position: relative;
    float: left;
    white-space: nowrap;
    transition: transform .3s;
  }
  .p-tabs__item{
    font-family: 'GillSansBold', "Microsoft YaHei", "Arial", Helvetica, sans-serif
    font-size: 14px;
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    color: #333;
    border-left: 1px solid #eee;
    cursor: pointer;
    &:first-of-type {
      border-left: 0 solid #eee;
    }
    &:last-of-type {
      background: #00336f;
      color: #fff;
    }
    &:last-of-type:hover {
      background: #00336f;
      color: #fff;
    }
    &.active {
      background: #00336f;
      color: #fff;
    }
     &.active:hover {
      background: #00336f;
    }
    &:hover {
      background: #eeeeee;
    }
    &.disabled{
      cursor: not-allowed;
      color: #aaa;
      &:hover{
        color: #aaa;
      }
    }
  }
  .p-tabs__content{
    position: relative;
    overflow: hidden;
  }
  .p-tabs__content_h{
    margin-top: 60px;
  }
  // .p-tab-pane{
  //   color: #fff;
  // }
  .fade {
    opacity: 0;
    -webkit-transition: opacity .15s linear;
    -o-transition: opacity .15s linear;
    transition: opacity .15s linear;
    display: block;
  }
  .fade.in {
    opacity: 1;
  }
}

@media (min-width: 299px) {
  .p-tabs{
    .p-tabs__item{
      font-size: 13px;
      // height: 42px;
      // line-height: 42px;
      padding: 0 14px;
    }
  }
}

@media (min-width: 468px) {
  .p-tabs{
    .p-tabs__item{
      font-size: 14px;
      // height: 46px;
      // line-height: 46px;
    }
  }
  // .p-tab-pane {
  //   margin-top: 30px;
  // }
}

@media (min-width: 899px) {
  .p-tabs{
    .p-tabs__item{
      font-size: 16px;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
    }
  }
}
@media (min-width: 992px) {
  .p-tabs .p-tabs__header_fixed {
    margin-top: 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/p-tabs/PTabs.vue